import { Facebook, Instagram } from "lucide-react";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "./ui/hover-card";

const FB_URL =
  "https://www.facebook.com/profile.php?id=61586966229301";
const IG_URL = "https://www.instagram.com/turning65medicarehelp/";
const TIKTOK_URL =
  "https://www.tiktok.com/@medicareadvisorszivae";

// TikTok glyph (lucide doesn't have one)
const TikTokIcon = ({ className = "" }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.36a8.16 8.16 0 0 0 4.77 1.52V6.4a4.85 4.85 0 0 1-1.84-.31z" />
  </svg>
);

/**
 * Inline circular "Turning 65 Medicare Help" badge with hover popover.
 * Use sizes: sm (32px), md (40px), lg (56px)
 */
export function MedicareBadge({ size = "md", className = "" }) {
  const sizes = {
    sm: "w-8 h-8",
    md: "w-10 h-10",
    lg: "w-14 h-14",
    xl: "w-24 h-24",
  };
  return (
    <HoverCard openDelay={80} closeDelay={120}>
      <HoverCardTrigger asChild>
        <a
          href={FB_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="medicare-badge-trigger"
          aria-label="Turning 65 Medicare Help — follow us on social media"
          className={`inline-flex shrink-0 align-middle rounded-full overflow-hidden ring-2 ring-orange-400/70 hover:ring-orange-500 shadow-md hover:shadow-lg bg-white transition-all duration-200 hover:scale-110 ${sizes[size]} ${className}`}
        >
          <img
            src="/assets/medicare-65-badge.png"
            alt="Turning 65 Medicare Help"
            className="w-full h-full object-cover"
          />
        </a>
      </HoverCardTrigger>
      <HoverCardContent
        side="top"
        align="center"
        className="w-auto p-3 bg-white border border-orange-200 shadow-xl"
        data-testid="medicare-badge-popover"
      >
        <div className="flex items-center gap-2">
          <p className="text-xs font-semibold text-gray-700 mr-1 whitespace-nowrap">
            Follow us:
          </p>
          <a
            href={FB_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="medicare-badge-fb"
            aria-label="Facebook"
            className="w-9 h-9 rounded-full bg-[#1877F2] hover:bg-[#1565d8] text-white inline-flex items-center justify-center transition-colors"
          >
            <Facebook className="w-4 h-4" />
          </a>
          <a
            href={IG_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="medicare-badge-ig"
            aria-label="Instagram"
            className="w-9 h-9 rounded-full text-white inline-flex items-center justify-center transition-opacity hover:opacity-85"
            style={{
              background:
                "radial-gradient(circle at 30% 110%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%)",
            }}
          >
            <Instagram className="w-4 h-4" />
          </a>
          <a
            href={TIKTOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="medicare-badge-tiktok"
            aria-label="TikTok"
            className="w-9 h-9 rounded-full bg-black hover:bg-gray-800 text-white inline-flex items-center justify-center transition-colors"
          >
            <TikTokIcon className="w-4 h-4" />
          </a>
        </div>
      </HoverCardContent>
    </HoverCard>
  );
}

export default MedicareBadge;
